import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { SquareProvider } from "./context/SquareContext";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Products from "./pages/Products";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Login from "./pages/auth/Login";
import SignUp from "./pages/auth/SignUp";
import ProfilePage from "./pages/ProfilePage";
import AdminDashboard from "./pages/admin/Dashboard";
import PaymentSuccess from "./pages/PaymentSuccess";

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <CartProvider>
          <SquareProvider>
            <div className="min-h-screen bg-gray-50">
              <Navbar />
              <main className="container mx-auto px-4 py-8">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/signup" element={<SignUp />} />
                  <Route path="/profile" element={<ProfilePage />} />
                  <Route path="/admin/dashboard" element={<AdminDashboard />} />
                  <Route path="/payment-success" element={<PaymentSuccess />} />
                </Routes>
              </main>
            </div>
          </SquareProvider>
        </CartProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;
